import React from 'react'

const GenericTitleP = ({children}) => {
  return (
    <p className='my-4 w-100 fs-2'>{children}</p>
  )
}

export default GenericTitleP